// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loadList[data-v-6996abce]{min-height:200px}.items[data-v-6996abce]{margin-bottom:20px}.items[data-v-6996abce] .title{width:100%}.gg_bottom[data-v-6996abce]{margin:20px auto 10px;text-align:center;color:#909399}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
